import React from 'react';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { TeachingGroup } from 'components/models/FormProps';
import { groupBy } from 'components/utils/group_by';
import { GroupNameAndResponses, getFormResponsesPercent, getFormResponsesRate } from '../../NonPublicAudienceContent';
import { StudentFormResponse } from '../../../Page';
import ResponsesTable from './ResponsesTable';

interface Props {
  responsesByGroup: { [key: number]: Array<StudentFormResponse> }
  teachingGroups: Array<TeachingGroup>;
  groupName: string;
  selectedResponsesTableRow: string | undefined;
  clickOnRowCallback: (groupNameAndResponses: GroupNameAndResponses<StudentFormResponse>) => void;
  allowMultipleSubmissions: boolean;
}

export default function TeachingGroupsResponsesTable(props: Props): React.ReactElement {
  const { responsesByGroup, teachingGroups, groupName, selectedResponsesTableRow, clickOnRowCallback, allowMultipleSubmissions } = props;
  const teachingGroupsBySubject: { [key: string]: Array<TeachingGroup> } = groupBy(teachingGroups, 'subject_description');

  return (
    <ResponsesTable groupName={groupName}>
      {
        Object.entries(teachingGroupsBySubject).map(([subject, tgs]) => (
          <React.Fragment key={subject}>
            <TableRow className="teaching-group-subject">
              <TableCell>{subject}</TableCell>
              <TableCell />
              <TableCell />
              <TableCell />
            </TableRow>
            {
              tgs.map(tg => {
                const rowId = String(tg.entity_id);
                const responses = responsesByGroup[tg.entity_id];
                const nonRespondentsCount = responses.filter(r => !r.hasSubmitted).length;
                const responsesColumnValue = allowMultipleSubmissions
                  ? responses.reduce((sum, r) => sum + (r.submissionCount ?? 0), 0)
                  : responses.length - nonRespondentsCount;

                return (
                  <TableRow
                    key={tg.entity_id}
                    selected={rowId === selectedResponsesTableRow}
                    hover
                    onClick={() => clickOnRowCallback({ name: rowId, responses })}
                  >
                    <TableCell>{tg.name}</TableCell>
                    <TableCell>{`${getFormResponsesRate(responses)} (${getFormResponsesPercent(responses)})`}</TableCell>
                    <TableCell>{responsesColumnValue}</TableCell>
                    <TableCell>{nonRespondentsCount}</TableCell>
                  </TableRow>
                );
              })
            }
          </React.Fragment>
        ))
      }
    </ResponsesTable>
  );
}
